import styled from "styled-components";
import * as M from "@discovery/prelude/lib/data/maybe";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Fold, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { Icon, Icons } from "../../components/atoms/icon";
import { primaryFontFamily, primaryFontFamilyBold, } from "../../styles/fontFamilyTypes";
import { branddark, brandhighlight, neutral10, neutral2, neutral8, } from "../../css/colors";
import { media } from "../../styles/breakpoints";
import { Background } from "../price-plan/index.styled";
const contents = [
    "Shorts",
    "discovery+ Originals",
    "Unlimited & exclusive BBC &History Content",
    "Live TV: India + International",
    "Best of Kids Shows",
    "Live Sports",
    "Ad Free Experience",
];
const BASIC = "basic";
const _Imagedata = Fold.compose(Optics._Col2Items, Fold.compose(Optics._ColItem2Image, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "logo"), Res._Response()));
export const Title = styled.span `
  font-family: ${primaryFontFamilyBold};
  font-size: 32px;
  color: ${neutral10};
  text-align: center;
  padding: 28px 0px 20px 0px;
  max-width: 50vw;
  line-height: 1.37;

  @media ${media.medium.down} {
    font-size: 16px;
  }

  @media ${media.xsmall.down} {
    max-width: 100vw;
    padding: 24px 54px;
  }
`;
export const Container = styled.div `
  width: 100vw;
  margin: 0 auto;
`;
const InnerContainer = styled.div `
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
const DetailsContainer = styled.div `
  position: relative;
`;
const DetailsInnerContainer = styled.div `
  position: relative;
  padding: 50px 60px 300px 60px;
  z-index: 1;
  max-width: 63.5vw;
  width: 100vw;
  margin: 0 auto;
  @media ${media.large.down} {
    max-width: 100vw;
  }
  @media ${media.small.down} {
    padding: 0px 16px 23px 16px;
  }
`;
const Text = styled.div `
  font-size: ${({ isHeader }) => (isHeader ? "24px" : "22px")};
  font-family: ${({ isHeader }) => isHeader ? primaryFontFamilyBold : primaryFontFamily};
  color: ${neutral8};
  padding: ${({ lastItem }) => (lastItem ? "15px 0px 80px 0px" : "15px 0px")};
  @media ${media.large.down} {
    font-size: 16px;
    padding: ${({ lastItem }) => (lastItem ? "10px 0px 80px 0px" : "10px 0px")};
  }
  @media ${media.xsmall.down} {
    padding: ${({ lastItem }) => (lastItem ? "7px 0px 40px 0px" : "7px 0px")};
    font-size: 12px;
    line-height: 1.33;
  }
`;
const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
  > span:first-child {
    font-family: ${primaryFontFamilyBold};
    color: ${neutral10};
  }
`;
const Header = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 24px;
  color: ${brandhighlight};
  padding: 15px 0px;
  font-family: ${primaryFontFamilyBold};
  width: 187px;
  justify-content: center;

  @media ${media.medium.down} {
    width: 120px;
  }

  @media ${media.large.down} {
    padding: 10px 0px;
    font-size: 16px;
  }

  @media ${media.xsmall.down} {
    width: 84px;
    font-family: ${primaryFontFamily};
    font-size: 12px;
    padding: 17px 9px 12px 9px;
  }
`;
const PremiumHeader = styled(Header) `
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: ${branddark};
  .icon {
    margin-left: 4px;
    @media ${media.xsmall.down} {
      width: 12px;
      height: 12px;
    }
  }
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed ${neutral2};
  :last-child {
    border: none;
  }
`;
const RowWrapper = styled.div `
  display: flex;
  flex-direction: row;
`;
const IconWrapper = styled.div `
  width: 187px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ lastItem }) => (lastItem ? "15px 0px 80px 0px" : "15px 0px")};

  @media ${media.medium.down} {
    width: 120px;
  }

  @media ${media.xsmall.down} {
    padding: ${({ lastItem }) => (lastItem ? "7px 0px 40px 0px" : "7px 0px")};
    width: 84px;
  }
  .icon {
    margin: 8px 4.5px 7px 5px;
    @media ${media.small.down} {
      width: 14px;
      height: 14px;
    }
  }
`;
const PremiumIconWrapper = styled.div `
  .premiumIcon {
    @media ${media.small.down} {
      width: 16px;
      height: 16px;
      margin-bottom: 4px;
    }
  }
`;
const PaidIconWrapper = styled(IconWrapper) `
  padding: ${({ lastItem }) => (lastItem ? "15px 0px 80px 0px" : "15px 0px")};
  background: ${({ lastItem }) => lastItem
    ? `linear-gradient(360deg, rgba(31, 34, 40, 0) 0%, #121317 80%);`
    : branddark};
  @media ${media.xsmall.down} {
    padding: ${({ lastItem }) => (lastItem ? "7px 0px 40px 0px" : "7px 0px")};
  }
`;
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    const templateIdM = Fold.preview(Optics._Col2TemplateId, data);
    const coverImageM = Fold.preview(_Imagedata, data);
    return {
        titleM,
        templateIdM,
        coverImageM,
    };
};
const PricePlanCompare = ({ titleM, templateIdM, coverImageM }) => {
    const templateId = M.fromMaybe(templateIdM, "");
    const BasicView = () => {
        return (React.createElement(Container, null,
            React.createElement(InnerContainer, null,
                React.createElement(RenderMaybe, null, M.map((title) => (title ? React.createElement(Title, null, title) : ""), titleM))),
            React.createElement(DetailsContainer, null,
                React.createElement(Background, { style: {
                        backgroundImage: M.foldMapConst((bg) => `url(${bg.attributes.src})`, "none", coverImageM),
                    } }),
                React.createElement(DetailsInnerContainer, null,
                    React.createElement(Wrapper, null,
                        React.createElement(TextWrapper, null,
                            React.createElement(Text, { style: { color: neutral10 }, isHeader: true }, "Content")),
                        React.createElement(RowWrapper, null,
                            React.createElement(Header, { style: { color: `${neutral8}` } }, "Free"),
                            React.createElement(PremiumHeader, null,
                                React.createElement(Text, { style: {
                                        color: brandhighlight,
                                        padding: 0,
                                        marginRight: 4,
                                    }, isHeader: true }, "Premium"),
                                React.createElement(PremiumIconWrapper, null,
                                    React.createElement(Icon, { type: Icons.PremiumIcon, className: "premiumIcon" }))))),
                    contents.map((txt, index) => (React.createElement(Wrapper, null,
                        React.createElement(Text, { lastItem: index === contents.length - 1, isHeader: false }, txt),
                        React.createElement(RowWrapper, null,
                            React.createElement(IconWrapper, { lastItem: index === contents.length - 1 },
                                React.createElement(Icon, { type: index === 0 ? Icons.YES : Icons.NO, className: "icon" })),
                            React.createElement(PaidIconWrapper, { lastItem: index === contents.length - 1 },
                                React.createElement(Icon, { type: Icons.YES, className: "icon" }))))))))));
    };
    switch (templateId) {
        case BASIC:
            return React.createElement(BasicView, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PricePlanCompare);

